<template>
  <el-drawer
    title="聊天记录"
    class="chat-data-drawer"
    :visible.sync="isShow"
    :before-close="onClose">
    <div class="chat-message-container" v-loading="isChatLoading">
      <MessageList :list="chatRecord" v-if="orderType === 1" />
      <AiMessageList :list="chatRecord" v-if="orderType === 2" />
      <NoData v-if="chatRecord.length === 0" />
    </div>
  </el-drawer>
</template>

<script>
import {queryWorkContentRecord, queryAIWorkContentRecord} from '../../api/order/index'
import AiMessageList from '../Public/AiMessageList.vue'
export default {
  props: ['isShow', 'orderType', 'workContent'],
  components: {
    AiMessageList
  },
  watch: {
    isShow (val) {
      if (val) {
        this.initData()
      }
    }
  },
  created () {
  },
  data () {
    return {
      isChatLoading: false,
      chatRecord: []
    }
  },
  methods: {
    onClose () {
      this.$emit('update:isShow', false)
    },
    async initData () {
      try {
        let params = {
          workContent: this.workContent
        }
        this.isChatLoading = true
        const {data} = this.orderType === 1 ? await queryWorkContentRecord(params) : await queryAIWorkContentRecord(params)
        if (data.resultCode === 0) {
          this.chatRecord = data.resultData || []
          this.$nextTick(() => {
            let container = document.querySelector('.chat-message-container')
            container.scrollTop = 9999
          })
        }
      } catch (error) {
      } finally {
        this.isChatLoading = false
      }
    }
  }
}
</script>

<style lang='less' scoped>
.chat-data-drawer{
  /deep/.el-drawer{
    width: 50%!important;
  }
  /deep/section.el-drawer__body{
    overflow-y: auto;
    padding-bottom: 0;
  }
  .drawer-footer{
    text-align: right;
  }
  /deep/.chat-message-container{
    max-height: 100%;
    overflow-y: auto;
    padding-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/OrderChatRecordDrawer.vue